import React from 'react';

import { RewardsPage } from 'features/reward/RewardsPage';

import { LoyaltyPromotionType } from 'generated/graphql-gateway';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { LoyaltyIncentiveCooldownMessage } from 'pages/loyalty/loyalty-incentives-components/loyalty-incentive-cooldown-message';
import LoyaltyRewards from 'pages/loyalty/loyalty-rewards/loyalty-rewards';
import { LoyaltyRewardsTabs } from 'pages/loyalty/loyalty-rewards/loyalty-rewards-tabs';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

function Rewards() {
  const enableLoyaltyServiceRewards = useFlag(LaunchDarklyFlag.ENABLE_LOYALTY_SERVICE_REWARDS);
  const isOneMenuStore = useEnableUnifiedMenu();

  if (enableLoyaltyServiceRewards && isOneMenuStore) {
    return <RewardsPage />;
  }

  return <LegacyRewards />;
}

const LegacyRewards = React.memo(() => {
  return (
    <>
      <LoyaltyRewardsTabs />
      <LoyaltyRewards />
      <LoyaltyIncentiveCooldownMessage incentiveType={LoyaltyPromotionType.REWARD} />
    </>
  );
});

export default React.memo(Rewards);
